export default function UnauthorizedPage() {
  return (
    <div className="w-full h-full bg-[#F3F3F3]">
      <div className="px-16 py-8">
        <h2>Oops! Something went wrong</h2>
        <p>You are unable to access this page</p>
      </div>
    </div>
  );
}
